module.exports = __webpack_public_path__ + "static/media/62.cd06988a.mp3";